import React from "react"
import Layout from "../../components/Layout"
import Seo from "../../components/Seo"
import JSONData from "../../assets/content/privacypolicy.json"

const privacypolicy = () => {
  return (
    <Layout>
      <Seo
        title="Privacy Policy"
        description="Privacy Policy for azszero app"
      />

      <div style={{ maxWidth: `960px`, margin: `1.45rem` }}>
        <h1>{JSONData.title}</h1>
        {JSONData.content.map((data, index) => {
          return (
            <div
              key={`content_item_${index}`}
              dangerouslySetInnerHTML={{ __html: data.item }}
            />
          )
        })}
      </div>
    </Layout>
  )
}

export default privacypolicy
